import { makeStyles } from '@material-ui/core'
import { Autorenew, Close, PowerSettingsNew } from '@material-ui/icons'
import React, { useState, useReducer, useEffect } from 'react'
import {
  useMutation,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { ToggleType } from '../../../../core/devices/passages/passage-set-boolean-status-button'
import { PassageDto } from '../../../../core/dto/device/passages/passage.dto'
import { PassageSelectStateDialog } from '../PassageDialogs'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import {
  passageSetPowerButtonInitialState,
  passageSetPowerButtonReducer,
} from '../../../../core/devices/passages/passage-set-power-button.reducer'
import { DateTime } from '../../../../core/common/date-time'

const useStyles = makeStyles((theme) => ({
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
    color: theme.palette.secondary.light,
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
  },
}))

export const PassageSetPowerButton = ({ ...props }) => {
  const { asRecurringJob, disabled, ...rest } = props
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const classes = useStyles()

  const [{ mutateQuery }, dispatch] = useReducer(
    passageSetPowerButtonReducer,
    passageSetPowerButtonInitialState,
  )
  const [dialogOpen, setDialogOpen] = useState(false)
  const [state, setState] = useState(false)
  const passage = useRecordContext<PassageDto>()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  useEffect(() => {
    if (state) {
      dispatch({ type: ToggleType.OFF })
    } else {
      dispatch({ type: ToggleType.ON })
    }
  }, [state])

  const handlePower = async (
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
    auditNote?: string,
  ) => {
    let query
    if (!asRecurringJob) {
      query = mutateQuery?.(passage, auditNote)
    } else {
      query = mutateQuery?.(
        passage,
        auditNote,
        recurringJobName as string,
        cronExpression as string,
        scheduledAt as DateTime,
      )
    }
    await mutate(query, {
      returnPromise: true,
      onFailure: (err) => notify(err?.message, 'error'),
    })
    refresh()
  }

  return (
    <>
      <PassageSelectStateDialog
        open={dialogOpen}
        confirm={handlePower}
        method="powerState"
        close={() => setDialogOpen(false)}
        state={state}
        setState={setState}
        asRecurringJob={asRecurringJob}
        OnIcon={<PowerSettingsNew className={classes.icon} />}
        OffIcon={
          <>
            <PowerSettingsNew className={classes.icon} />
            <Close fontSize="large" className={classes.crossIcon} />
          </>
        }
        withAuditNote
      />
      <Button
        disabled={
          !hasAuthority(Authority.PASSAGES_SET_POWER_BUTTON) ||
          loading ||
          mutationLoading ||
          disabled === true
        }
        variant="contained"
        color="primary"
        onClick={() => setDialogOpen(true)}
        label={
          !asRecurringJob ? 'resources.passages.actions.setPowerState' : ''
        }
        useSmallVersionBreakpoint={false}
        {...rest}
      >
        {asRecurringJob ? <Autorenew /> : undefined}
      </Button>
    </>
  )
}
